<template>
  <div>
    <div
      :class="{ 'page-overlay': adding }"
      @click="adding = false"
    />
    <div
      class="new-post card"
      :class="{ closed: !adding }"
      :style="{ cursor: adding ? 'auto' : 'pointer' }"
      @click="adding = true"
    >
      <div
        v-if="!adding"
        class="stretch"
      >
        <avatar />
        <span>Post a message or create a listing</span>
      </div>

      <post-form
        v-else
        :group-id="group"
        @close="adding = false;"
      />
    </div>
    <div
      v-if="adding"
      ref="new-post-mobile"
      class="new-post-mobile card"
      :class="{ closed: !adding }"
    >
      <post-form
        :group-id="group"
        @close="adding = false;"
      />
    </div>
    <div
      v-if="userData && !adding && showAddButton"
      class="new-post-floating"
      @click="adding = true; scrollToForm()"
    >
      <plus-icon
        decorative
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Avatar from '@/components/Avatar.vue';
import PostForm from '@/views/posts/PostForm.vue';

export default {
  name: 'NewPostCard',
  components: {
    Avatar,
    PostForm,
  },
  props: {
    group: { type: Number, default: null },
  },
  data() {
    return {
      adding: false,
    };
  },
  computed: {
    ...mapState([
      'showAddButton',
    ]),
  },
  methods: {
    async scrollToForm() {
      await this.$nextTick();

      const postForm = this.$refs['new-post-mobile'];

      if (this.isElementInViewport(postForm)) {
        postForm.focus();
      } else {
        postForm.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      setTimeout(() => {
        postForm.focus();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-overlay {
    position: fixed;
    z-index: 2;
    background-color: rgba(23, 23 ,23, 0.3);
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    transition-property: background-color;
    transition-duration: 0.5s;
  }

  .new-post {
    display: none;
    margin-bottom: 1rem;

    span {
      padding: 10px;
    }
  }

  .new-post-mobile {
    display: none;
  }

  .new-post-floating {
    z-index: 2;
    position: fixed;
    right: 8px;
    bottom: calc(var(--bottom-bar-height) + 20px);
    background-color: var(--blue);
    border-radius: 50%;
    text-align: center;
    border: 2px solid white;
    width: 60px;
    height: 60px;
  }

  .new-post-floating .material-design-icon svg {
    fill: white;
    border-radius: 100%;
  }

  .new-post-floating .material-design-icon {
    border-radius: 100%;
    font-size: 2.3rem;
    height: 42px;
  }

  .closed {
    max-height: 75px !important;
  }

  @media (max-width: 1024px) {
    .new-post-mobile {
      display: block;
      position: relative;
      z-index: 2;

      max-height: 1000px;

      transition-property: all;
      transition-duration: .5s;
      transition-timing-function: linear;
    }
  }

  @media (min-width: 1025px) {
    .new-post {
      display: flex;
      position: relative;
      z-index: 2;

      max-height: 1000px;

      transition-property: all;
      transition-duration: .5s;
      transition-timing-function: linear;
    }

    .new-post-floating {
      display: none;
    }
  }
</style>
